export function funnelPath(id) {
  return `${funnelsPath()}/${id}`;
}

export function funnelsPath() {
  return '/funnels';
}

